import React, { useState } from "react";
import logo from "./assets/logo.png";
import accHero from "./assets/acc-hero.png";
import colorLogo from "./assets/colorlogo.png";
import heroLogo from "./assets/Web-hero.png";


// Hallinan Labs — Homepage skeleton
// TailwindCSS utility classes throughout. Drop into your React/Next.js app.
// Image placeholders use /assets/... — swap with your actual paths.

export default function HallinanLabsHome() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const navItems = [
    { label: "Studio", href: "#studio" },
    { label: "Contact", href: "#contact" },
  ];

  return (
    <div className="min-h-screen bg-neutral-950 text-neutral-100">
      {/* Announcement Banner */}
      <a
        href="#featured"
        className="block w-full bg-gradient-to-r from-rose-600 via-fuchsia-600 to-indigo-600 text-center text-sm sm:text-base font-medium py-2 hover:opacity-95 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-400 focus:ring-offset-neutral-950"
      >
        🎄 New: A Christmas Carol — But with Anime Girls. Learn more →
      </a>

      {/* Header / Nav */}
      <header className="sticky top-0 z-50 backdrop-blur bg-[#00464e]/70 border-b border-white/10">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="flex h-16 items-center justify-between">
            {/* Logo */}
            <a href="#home" className="flex items-center gap-3">
              <img
                src={logo} 
                alt="Hallinan Labs logo"
                className="h-8 w-8"
              />
              <span className="text-lg font-semibold tracking-wide">Hallinan Labs</span>
            </a>

            {/* Desktop nav */}
            <nav className="hidden md:flex items-center gap-6">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="text-sm font-medium text-neutral-200 hover:text-white transition-colors"
                >
                  {item.label}
                </a>
              ))}
              {/*<a
                href="#language"
                className="text-xs uppercase tracking-wider text-neutral-300 hover:text-white"
                title="Switch language"
              >
                EN / 日本語
              </a> */}
            </nav>

            {/* Mobile menu button */}
            <button
              className="md:hidden inline-flex items-center justify-center rounded-xl p-2 hover:bg-white/10"
              onClick={() => setMobileOpen((o) => !o)}
              aria-label="Toggle navigation"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="h-6 w-6">
                {mobileOpen ? (
                  <path fillRule="evenodd" d="M18.3 5.7a1 1 0 0 1 0 1.4L13.41 12l4.89 4.9a1 1 0 1 1-1.42 1.4L12 13.41l-4.9 4.89a1 1 0 1 1-1.4-1.42L10.59 12 5.7 7.1A1 1 0 1 1 7.1 5.7L12 10.59l4.9-4.89a1 1 0 0 1 1.4 0z" clipRule="evenodd" />
                ) : (
                  <path fillRule="evenodd" d="M4 6h16v2H4V6zm0 5h16v2H4v-2zm0 5h16v2H4v-2z" clipRule="evenodd" />
                )}
              </svg>
            </button>
          </div>
        </div>

        {/* Mobile nav panel */}
        {mobileOpen && (
          <div className="md:hidden border-t border-white/10">
            <div className="px-4 py-3 space-y-2">
              {navItems.map((item) => (
                <a
                  key={item.label}
                  href={item.href}
                  className="block rounded-lg px-3 py-2 text-base hover:bg-white/10"
                  onClick={() => setMobileOpen(false)}
                >
                  {item.label}
                </a>
              ))}
              <a href="#language" className="block rounded-lg px-3 py-2 text-sm text-neutral-300 hover:bg-white/10" onClick={() => setMobileOpen(false)}>
                EN / 日本語
              </a>
            </div>
          </div>
        )}
      </header>

      {/* Hero */}
      <section id="home" className="relative isolate">
        <div
          className="relative h-[72vh] w-full"
          style={{
            backgroundImage: `url(${accHero})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
          aria-label="Splash illustration from A Christmas Carol: But with Anime Girls"
        >
          <div className="absolute inset-0 bg-gradient-to-t from-neutral-950 via-neutral-950/40 to-transparent"></div>
          <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,255,255,0.08),rgba(0,0,0,0))]"></div>
          <div className="relative mx-auto flex h-full max-w-7xl items-end px-4 pb-10 sm:px-6 lg:px-8">
            <div className="max-w-2xl">
              <p className="mb-3 inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold ring-1 ring-inset ring-white/10">
                Visual Novel • Hallinan Classics
              </p>
                <h1 className="text-3xl sm:text-5xl font-extrabold leading-tight">
                  A Christmas Carol:
                  <span className="block text-fuchsia-300">But with Anime Girls</span>
                </h1>
              <p className="mt-3 text-neutral-300">
                Read the Charles Dickens' classic... but with Anime Girls.
              </p>
              <div className="mt-6 flex flex-wrap items-center gap-3">
                <a href="https://store.steampowered.com/app/3976490/A_Christmas_Carol_But_With_Anime_Girls/" className="rounded-2xl bg-fuchsia-600 px-5 py-2.5 font-semibold hover:bg-fuchsia-500">
                  Steam Page
                </a>
                <a href="#featured" className="rounded-2xl border border-white/15 bg-white/5 px-5 py-2.5 font-semibold hover:bg-white/10">
                  Learn More
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Game Section */}
      <section id="featured" className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-8 lg:grid-cols-2 lg:gap-12 items-center">
          <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-white/5 shadow-2xl">
            <iframe
              src="https://www.youtube.com/embed/LOJhVfsXYNc?si=my80LK8wt5Ivpztf"
              title="A Christmas Carol: But with Anime Girls — Trailer"
              loading="lazy"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowFullScreen
              referrerPolicy="strict-origin-when-cross-origin"
              className="w-full aspect-video"
            />
          </div>
          <div>
            <div className="mb-3 inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold ring-1 ring-inset ring-white/10">
              Featured Title
            </div>
            <h2 className="text-2xl sm:text-3xl font-bold">A Christmas Carol: But with Anime Girls</h2>
            <p className="mt-3 text-neutral-300">
              Ever wanted to read A Christmas Carol, but struggled with the lack of Anime Girls? Have we got a game for you!
            </p>
            <p className="mt-3 text-neutral-300">
              Releases: <strong>December 2025</strong>. 
            </p>
            <ul className="mt-4 list-disc space-y-2 pl-5 text-neutral-300">
              <li>A full cast of gender-swapped kawaii anime girls!</li>
              <li>Atmospheric music, SFX, and authentic Japanese interjections!</li>
              <li>Cinematic animations to transport you straight into anime girl-Victorian London!</li>
              <li>20+ dramatic CGs</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Studio/About */}
      <section id="studio" className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-2">
          <div>
            <h3 className="text-xl sm:text-2xl font-bold">About Hallinan Labs</h3>
            <p className="mt-3 text-neutral-300">
              Hallinan Labs is an indie one-man visual novel studio crafting classic literature with a playful anime twist. Discover the classics and so much moe with Hallinan Labs!
            </p>
          </div>
          <div className="relative overflow-hidden rounded-3xl border border-white/10 bg-white/5">
            <img src={heroLogo} alt="Hallinan Labs Logo" className="aspect-[16/10] w-full object-cover" />
          </div>
        </div>
      </section>

      {/* Contact */}
      <section id="contact" className="mx-auto max-w-7xl px-4 pb-24 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-2">
          <div>
            <h3 className="text-xl sm:text-2xl font-bold">Contact</h3>
            <p className="mt-3 text-neutral-300">Business inquiries, press, and collaboration requests welcome.</p>
            <ul className="mt-4 space-y-2 text-neutral-300">
              <li><strong>Email:</strong> info at hallinanlabs.com</li>
              <li><strong>Twitter/X:</strong> @HallinanLabs</li>
            </ul>
          </div>
          {/*<div className="overflow-hidden rounded-3xl border border-white/10 bg-white/5 p-6">
            <form className="grid gap-4">
              <div>
                <label className="mb-1 block text-sm text-neutral-300">Name</label>
                <input className="h-11 w-full rounded-xl border border-white/10 bg-white/5 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-fuchsia-500" />
              </div>
              <div>
                <label className="mb-1 block text-sm text-neutral-300">Email</label>
                <input type="email" className="h-11 w-full rounded-xl border border-white/10 bg-white/5 px-4 text-sm focus:outline-none focus:ring-2 focus:ring-fuchsia-500" />
              </div>
              <div>
                <label className="mb-1 block text-sm text-neutral-300">Message</label>
                <textarea rows={4} className="w-full rounded-xl border border-white/10 bg-white/5 p-4 text-sm focus:outline-none focus:ring-2 focus:ring-fuchsia-500" />
              </div>
              <a
              href="mailto:contact&#64;hallinanlabs&#46;com?subject=Hallinan%20Labs%20Inquiry"
              className="inline-flex h-11 items-center justify-center rounded-xl bg-fuchsia-600 px-5 text-sm font-semibold hover:bg-fuchsia-500">Email us
              </a>
            </form>
          </div>*/}
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-white/10 bg-neutral-950/70">
        <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8">
          <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
            <div>
              <div className="flex items-center gap-3">
                <img src={heroLogo} alt="Hallinan Labs" className="h-7 w-7" />
                <span className="font-semibold">Hallinan Labs</span>
              </div>
              <p className="mt-3 text-sm text-neutral-400">The classics, and so much moe.</p>
            </div>
            <div>
              <h5 className="mb-3 text-sm font-semibold">Studio</h5>
              <ul className="space-y-2 text-sm text-neutral-300">
                <li><a href="#studio" className="hover:underline">About</a></li>
              </ul>
            </div>
            <div>
              <h5 className="mb-3 text-sm font-semibold">Games</h5>
              <ul className="space-y-2 text-sm text-neutral-300">
                <li><a href="#featured" className="hover:underline">A Christmas Carol</a></li>
              </ul>
            </div>
            {/*<div>
              <h5 className="mb-3 text-sm font-semibold">Legal</h5>
              <ul className="space-y-2 text-sm text-neutral-300">
                <li><a href="#privacy" className="hover:underline">Privacy</a></li>
                <li><a href="#terms" className="hover:underline">Terms</a></li>
                <li><a href="#cookies" className="hover:underline">Cookies</a></li>
              </ul>
            </div>*/}
          </div>
          <div className="mt-8 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-6 sm:flex-row">
            <p className="text-xs text-neutral-500">© {new Date().getFullYear()} Hallinan Labs. All rights reserved.</p>
            <div className="flex items-center gap-3 text-sm text-neutral-300">
              <a href="#language" className="hover:underline">EN</a>
              <span aria-hidden>•</span>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
